<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> ویرایش کد تخفیف ریفرال </template>
    <BRow v-if="defaultDiscountCodeData">
      <BCol cols="12" md="6">
        <MasterPicker
          :defaultSelectedMaster="tempDefaultSelectedMaster"
          @getMaster="setMaster"
        ></MasterPicker>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          readonly
          :isText="true"
          customRules="required|min:1"
          inputId="masterDiscountCashBack"
          inputLabel="درصد بازگشت وجه به استاد (درصد)"
          inputPlaceholder="5"
          v-model="defaultDiscountCodeData.masterDiscountCashBack"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          readonly
          :isText="true"
          customRules="required|min:1"
          inputId="studentDiscountValue"
          :inputLabel="handleInputLabel"
          :inputPlaceholder="handleInputPlaceholder"
          v-model="defaultDiscountCodeData.studentDiscountValue"
        >
          <template #append>
            {{ handleInputAppend }}
          </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="maxUseCount"
          inputLabel="تعداد قابل استفاده"
          inputPlaceholder="5"
          v-model="defaultDiscountCodeData.maxUseCount"
        >
          <template #append> بار </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="minFinalPriceLimit"
          inputLabel="حداقل مبلغ سفارش"
          inputPlaceholder="50000"
          v-model="defaultDiscountCodeData.minFinalPriceLimit"
        >
          <template #append> تومان </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomDatePicker
          v-model="defaultDiscountCodeData.expireDate"
          inputId="defaultDiscountCodeDataExpireDate"
          @getSelectedDate="setExpireDate"
          inputLabel="تاریخ اتمام تخفیف"
          inputPlaceholder="1403/06/05"
        >
        </CustomDatePicker>
      </BCol>
      <BCol cols="auto" class="ml-auto mt-1">
        <BButton variant="info" @click="sendUpdateDiscountCodeRequest">
          ویرایش کد ریفرال
        </BButton>
      </BCol>
    </BRow>
    <hr />
    <BRow>
      <BCol cols="12">
        <MasterDiscountCodeOrders
          :masterDiscountCodeId="$route.params.id"
        ></MasterDiscountCodeOrders>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getASingleDiscountCode();
  },
  data() {
    return {
      isLoading: false,
      defaultDiscountCodeData: null,
      tempDefaultSelectedMaster: null,
    };
  },
  methods: {
    async getASingleDiscountCode() {
      // GetASingleDiscountCode
      try {
        this.isLoading = true;
        const _this = this;
        const getASingleDiscountCode = new GetASingleDiscountCode(_this);
        getASingleDiscountCode.setRequestParam({
          input: _this.$route.params.id,
        });
        await getASingleDiscountCode.fetch((res) => {
          _this.defaultDiscountCodeData = res.data;
          _this.tempDefaultSelectedMaster = {
            fullName: res.data.userFullName,
            userId: res.data.userId,
          };
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async sendUpdateDiscountCodeRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let updateASingleDiscountCode = new UpdateASingleDiscountCode(_this);
        updateASingleDiscountCode.setRequestParamDataObj(
          _this.defaultDiscountCodeData
        );
        await updateASingleDiscountCode.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کد تخفیف ریفرال با موفقیت ویرایش شد.",
              },
            });
            _this.getASingleDiscountCode();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setExpireDate(expireDate) {
      if (expireDate) {
        this.defaultDiscountCodeData.expireDate = new Date(
          expireDate
        ).toISOString();
      } else {
        this.defaultDiscountCodeData.expireDate = null;
      }
    },
    setMaster(master) {
      if (master) {
        this.defaultDiscountCodeData.userId = master.userId;
      } else {
        this.defaultDiscountCodeData.userId = null;
      }
    },
  },
  computed: {
    handleInputPlaceholder() {
      return this.defaultDiscountCodeData.discountType == 1 ? "10000" : "5";
    },
    handleInputAppend() {
      return this.defaultDiscountCodeData.discountType == 1 ? "تومان" : "%";
    },
    handleInputLabel() {
      return `تخفیف برای زبان آموز (${
        this.defaultDiscountCodeData.discountType == 1 ? "مبلغ" : "درصد"
      })`;
    },
  },
  components: {
    PageWrapper,
    MasterPicker,
    DiscountTypePicker,
    CustomAppendText,
    CustomDatePicker,
    MasterDiscountCodeOrders,
    BRow,
    BCol,
    BButton,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import DiscountTypePicker from "@/views/components/Discount/DiscountTypePicker.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import MasterDiscountCodeOrders from "@/views/components/MasterDiscountCode/MasterDiscountCodeOrders.vue";
import { BRow, BCol, BButton } from "bootstrap-vue";
import {
  GetASingleDiscountCode,
  UpdateASingleDiscountCode,
} from "@/libs/Api/MasterDiscountCodes";
</script>
